import React, { useState, useEffect } from "react";
import "./EditarProfessorModal.css";

const EditarProfessorModal = ({ professor, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    nome: "",
    numeroBI: "",
    nivelAcademico: "",
    telefone: "",
    email: "",
    genero: "",
    Disciplinas: [],
    Classes: [],
    experiencia: "",
    ativo: true,
  });

  useEffect(() => {
    if (professor) {
      setFormData({
        nome: professor.nome || "",
        numeroBI: professor.numeroBI || "",
        nivelAcademico: professor.nivelAcademico || "",
        telefone: professor.telefone || "",
        email: professor.email || "",
        genero: professor.genero || "",
        Disciplinas: professor.Disciplinas || [],
        Classes: professor.Classes || [],
        experiencia: professor.experiencia || "",
        ativo: professor.ativo ?? true,
      });
    }
  }, [professor]);

  const opcoesDisciplinas = [
    "Matemática",
    "Português",
    "Física",
    "Química",
    "Ed.Visual",
    "Ed.Física",
    "Biologia",
    "Agro-pecuária",
    "História",
    "Geografia",
    "Filosofia",
    "Francês",
    "Inglês",
  ];

  const opcoesClasses = [
    "1ª Classe",
    "2ª Classe",
    "3ª Classe",
    "4ª Classe",
    "5ª Classe",
    "6ª Classe",
    "7ª Classe",
    "8ª Classe",
    "9ª Classe",
    "10ª Classe",
    "11ª Classe",
    "12ª Classe",
  ];

  const handleChange = (e) => {
    const { name, value, type, checked, options } = e.target;

    if (type === "select-multiple") {
      const selectedOptions = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
      setFormData((prev) => ({ ...prev, [name]: selectedOptions }));
    } else if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal editar-professor-modal">
      <div className="modal-content">
        <h3>Editar Professor</h3>
        <form onSubmit={handleSubmit}>
          <label>
            Nome:
            <input
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Número BI:
            <input
              type="text"
              name="numeroBI"
              value={formData.numeroBI}
              onChange={handleChange}
            />
          </label>
          <label>
            Nível Acadêmico:
            <input
              type="text"
              name="nivelAcademico"
              value={formData.nivelAcademico}
              onChange={handleChange}
            />
          </label>
          <label>
            Telefone:
            <input
              type="text"
              name="telefone"
              value={formData.telefone}
              onChange={handleChange}
            />
          </label>
          <label>
            Email:
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </label>
          <label>
            Gênero:
            <select name="genero" value={formData.genero} onChange={handleChange}>
              <option value="">Selecione</option>
              <option value="Masculino">Masculino</option>
              <option value="Feminino">Feminino</option>
              <option value="Outro">Outro</option>
            </select>
          </label>

          <label>
            Disciplinas:
            <select
              multiple
              name="Disciplinas"
              value={formData.Disciplinas}
              onChange={handleChange}
              size={5}
            >
              {opcoesDisciplinas.map((disc) => (
                <option key={disc} value={disc}>
                  {disc}
                </option>
              ))}
            </select>
          </label>

          <label>
            Classes:
            <select
              multiple
              name="Classes"
              value={formData.Classes}
              onChange={handleChange}
              size={5}
            >
              {opcoesClasses.map((cls) => (
                <option key={cls} value={cls}>
                  {cls}
                </option>
              ))}
            </select>
          </label>

          <label>
            Experiência:
            <textarea
              name="experiencia"
              value={formData.experiencia}
              onChange={handleChange}
              rows={3}
            />
          </label>

          <label>
            Ativo:
            <input
              type="checkbox"
              name="ativo"
              checked={formData.ativo}
              onChange={handleChange}
            />
          </label>

          <div className="botoes-inferiores">
            <button type="submit" className="btn-editar">
              Salvar
            </button>
            <button type="button" className="btn-fechar" onClick={onClose}>
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditarProfessorModal;
